import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const routingIpv6FilterOperators = unreadonly([
  ...filterOperators.routing,
  ...filterOperators.empty,
  ...filterOperators.regexCaseSensitive,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type RoutingIpv6FilterOperator =
  (typeof routingIpv6FilterOperators)[number];

export type RoutingIpv6TableFilter = TableFilterBase & {
  type: 'routingIpv6';
};

export const createRoutingIpv6Filter = (): RoutingIpv6TableFilter => ({
  type: 'routingIpv6',
  operators: routingIpv6FilterOperators,
});
